/**
 *  문자 서비스 발송 메시지 타입
 */
export const MSG_SERVICE_SEND_TYPE = {
  /**
   *  SMS
   */
  SMS: 'S',
  /**
   *  LMS
   */
  LMS: 'L',
  /**
   *  MMS
   */
  MMS: 'M',
};

/**
 *  문자 서비스 발송 메시지 타입 SELECT LIST
 */
export const MSG_SERVICE_SEND_TYPE_SELECT_LIST = [
  {
    id: MSG_SERVICE_SEND_TYPE.SMS,
    name: 'SMS',
  },
  {
    id: MSG_SERVICE_SEND_TYPE.LMS,
    name: 'LMS',
  },
];

/**
 *  문자 서비스 발송 텍스트 최대 Byte
 */
export const MSG_SERVICE_SEND_MAXIMUM_BYTE_OF_TEXT = {
  /**
   *  SMS
   */
  [MSG_SERVICE_SEND_TYPE.SMS]: 90,
  /**
   *  LMS
   */
  [MSG_SERVICE_SEND_TYPE.LMS]: 2000,
};

/**
 *  문자 서비스 발송 모달 섹션 타입
 */
export const MSG_SERVICE_SEND_MODAL_SECTION_TYPE = {
  /**
   *  메시지 타입을 선택하는 섹션
   */
  SELECT_MSG_SERVICE_TYPE_SECTION: 0,
  /**
   *  메시지를 발송하는 폼 섹션
   */
  SEND_MSG_SERVICE_FORM_SECTION: 1,
};

/**
 *  문자 LMS 서비스 제목 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_LMS_SUBJECT_TEXT = 50;
